type ThrowSentryTestErrorProps = {
  /** Same message the server throws, from {@link getSentryTestErrorMessage}. */
  message: string;
};

/**
 * Throws during render so the crash looks like a real UI exception in Sentry.
 */
export const ThrowSentryTestError = ({
  message,
}: ThrowSentryTestErrorProps) => {
  throw new Error(message);
};
